import * as React from 'react'

const Cross = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-label='Cross logo'
    fill='none'
    height='18'
    role='img'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='18'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Cross logo</title>
    <path d='M18 6 6 18' />
    <path d='m6 6 12 12' />
  </svg>
)

export default Cross



// WEBPACK FOOTER //
// ./src/components/icons/ui/Cross.tsx